import tipoFinanciamentoList from './tipoFinanciamentoList'



export const tipoFinanciamentoEntradaDadosList = ( tipoFinanciamento ) => {
    
    let tipoFinanciamentoEntradaDadosListAux = []

    tipoFinanciamentoList.forEach( (linha, index) => {

        if (linha.id === tipoFinanciamento || linha.ativo === 'S') {

            tipoFinanciamentoEntradaDadosListAux.push(
                linha
            )
        }
    })

    return tipoFinanciamentoEntradaDadosListAux
}

export default tipoFinanciamentoEntradaDadosList